import _ from "lodash";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import React from "react";
import classes from "./SubjectGroupWithSubjectViewOnly.scss";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip, Tag } from "@toddle-edu/ds-web";
import { getLabelWithArchivedText } from "Utils";
import { getIconComponent } from "Administrator/modules/Utils";
import { compose } from "lib/apolloClient";
import {
  IndividualsSocietiesDuotone,
  ArtDuotone,
  PhysicalHealthEducationDuotone,
  LanguageAcquisitionDuotone,
  LanguageLiteratureDuotone,
  MathematicsDuotone,
  DesignDuotone,
  SciencesDuotone,
} from "@toddle-edu/ds-icons";

const iconSize = "small";

const iconContainerStyle = {
  height: "28px",
};

const tagColor = { SL: "teal", HL: "pink" };

const ICON_SUBJECT_GROUP_MAPPING = [
  {
    iconKey: "ARTS",
    icon: <ArtDuotone size={iconSize} color="violet" />,
  },
  {
    iconKey: "L&L",
    icon: <LanguageLiteratureDuotone size={iconSize} color="yellow" />,
  },
  {
    iconKey: "LA",
    icon: <LanguageAcquisitionDuotone size={iconSize} color="yellow" />,
  },
  {
    iconKey: "DESIGN",
    icon: <DesignDuotone size={iconSize} color="pink" />,
  },
  {
    iconKey: "SCI",
    icon: <SciencesDuotone size={iconSize} color="blue" />,
  },
  {
    iconKey: "MATH",
    icon: <MathematicsDuotone size={iconSize} color="violet" />,
  },
  {
    iconKey: "PHE",
    icon: <PhysicalHealthEducationDuotone size={iconSize} color="blue" />,
  },
  {
    iconKey: "I&S",
    icon: <IndividualsSocietiesDuotone size={iconSize} color="pink" />,
  },
  {
    iconKey: "COMMON",
    icon: <IndividualsSocietiesDuotone size={iconSize} color="pink" />,
  },
];

class SubjectGroupWithSubjectViewOnly extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  renderEdit = () => {
    const { value, options, t } = this.props;
    const subject = _.find(options, option => _.includes(value, option.id));
    const subjectGroup = _.get(subject, "subjectGroup", "");
    const textClass = classNames("text-subtitle-1", classes.textContainer);
    const isArchived = _.get(subject, "isArchived", false);
    const label = _.get(subject, "name", "");

    return (
      <div className={classes.container}>
        <div className={classes.boxContainer}>
          {_.get(
            _.find(ICON_SUBJECT_GROUP_MAPPING, {
              iconKey: _.get(subjectGroup, "constants.iconKey", "COMMON"),
            }),
            "icon",
            ""
          )}
          <Tooltip tooltip={_.get(subjectGroup, "name", "")}>
            <div className={textClass}>{_.get(subjectGroup, "name", "")}</div>
          </Tooltip>
        </div>
        <div className={classes.boxContainer}>
          {getIconComponent({
            icon: _.get(subject, "icon", ""),
            containerStyle: iconContainerStyle,
          })}
          <Tooltip
            tooltip={label + (isArchived ? ` (${t("common:archived")})` : ``)}
          >
            <div className={textClass}>
              {getLabelWithArchivedText({
                t,
                label,
                isArchived,
              })}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  };

  renderView = () => {
    const {
      value: { subjectValue, subjectLevelValue },
    } = this.props;

    return (
      <div className={classes.viewContainer}>
        <div
          className={classNames("text-body-2", classes.subjectValueContainer)}
        >
          {subjectValue}
        </div>
        {_.map(subjectLevelValue, value => {
          return (
            <Tag size="xx-small" color={tagColor[value]}>
              {value}
            </Tag>
          );
        })}
      </div>
    );
  };
}

SubjectGroupWithSubjectViewOnly.defaultProps = {
  ...UIBaseComponent.defaultProps,
  value: [],
};

SubjectGroupWithSubjectViewOnly.propTypes = {
  ...UIBaseComponent.propTypes,
  value: PropTypes.array,
};

export default compose(I18nHOC({ resource: ["common"] }))(
  SubjectGroupWithSubjectViewOnly
);
